import * as React from 'react'
import {
    DictionaryValue,
    Button,
    CountdownText,
    Grid,
} from '../../components'
import bind from 'bind-decorator'
import { Auth } from 'aws-amplify'
import './ConfirmSignUp.scss'

type Props = {
    error?: Error
    username: string | null
    email: string | null
    confirmationCode: string | null
}

type State = {
    disableTimeout: boolean
    confirmed: boolean
    isVerifying: boolean
    error?: Error
}

class ConfirmSignUp extends React.Component<Props, State> {
    readonly state: State = {
        disableTimeout: false,
        confirmed: false,
        isVerifying: false,
    }

    @bind
    handleCallback() {
        const { username } = this.props
        if (username !== null) {
            this.sendVerificationEmail(username)
        }
        throw 'Invalid Username'
    }

    @bind
    async sendVerificationEmail(username: string) {
        try {
            await Auth.resendSignUp(username)
            this.setState({
                disableTimeout: true,
            })

            setTimeout(() => {
                this.setState({ disableTimeout: false })
            },         60000)
        } catch (e) {
            alert(e.message)
        }
    }

    @bind
    handleEmailDecode() {
        const { username, email } = this.props
        if (username !== null && email !== null) {
            const buff = new Buffer(email, 'base64')
            const emailDecoded = buff.toString('ascii')
            return emailDecoded
        }
        return null
    }

    @bind
    handleVerification() {
        const { username, confirmationCode } = this.props
        const { confirmed } = this.state

        if (confirmationCode && username && !confirmed) {
            try {
                this.setState({ isVerifying: true, error: undefined })
                Auth.confirmSignUp(username, confirmationCode)
                .then((response) => {
                    if (response === 'SUCCESS') {
                        this.setState({ confirmed: true, isVerifying: false })
                    } else {
                        throw 'Invalid Confirmation Link'
                    }
                })
            } catch (error) {
                this.setState({ error })
            }
        } else {
            throw 'Invalid Confirmation Link'
        }
    }

    render() {
        const { confirmed, isVerifying, disableTimeout } = this.state

        const emailDecoded = this.handleEmailDecode()

        const t = new Date()
        t.setMinutes(t.getMinutes() + 1)

        return (
            <div className='confirm-sign-up'>
                <Grid>
                    <div className='row'>
                        <div
                            className={`
                                col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4
                            `}
                        >
                            {!confirmed ? <>
                                <h1 className='confirm-sign-up__page-heading'>
                                    <DictionaryValue token='confirm-sign-up.title' />
                                </h1>
                                <div className='confirm-sign-up__page-intro'>
                                    <DictionaryValue token='confirm-sign-up.intro' />
                                </div>
                                {emailDecoded !== null ?
                                <>
                                    <div className='confirm-sign-up__user-data'>
                                        <span className='confirm-sign-up__data-label'>Your Email:</span> {emailDecoded}
                                    </div>
                                    <Button
                                        buttonType='primary'
                                        buttonStyle='square'
                                        type='button'
                                        disabled={isVerifying}
                                        callback={this.handleVerification}
                                        className='confirm-sign-up__button confirm-sign-up__button--send'
                                    >
                                        {isVerifying ?
                                        <>
                                            Verifying ... <i className='fa fa-spinner fa-spin' />
                                        </> : <>
                                            Verify Now
                                        </>}
                                    </Button>
                                </> :
                                    <Button
                                        buttonType='primary'
                                        buttonStyle='square'
                                        type='button'
                                        disabled={disableTimeout}
                                        callback={this.handleCallback}
                                        className='confirm-sign-up__button confirm-sign-up__button--send'
                                    >
                                        Resend Verification Email
                                        {disableTimeout ? <>
                                            <span> (</span>
                                            <CountdownText to={Math.floor(t.getTime() / 1000)}/>
                                            <span>)</span>
                                        </>
                                        : ''}
                                    </Button>
                                }
                            </> : <>
                                <h1 className='confirm-sign-up__page-heading'>
                                    <DictionaryValue token='confirm-sign-up.success.title' />
                                </h1>
                                <div className='confirm-sign-up__page-intro'>
                                    <DictionaryValue token='confirm-sign-up.success.intro' />
                                </div>
                                <Button
                                    buttonType='primary'
                                    buttonStyle='square'
                                    type='button'
                                    redirectUrl='/account'
                                    className='confirm-sign-up__button confirm-sign-up__button--login'
                                >
                                    Login Now
                                </Button>
                            </>}
                        </div>
                    </div>
                </Grid>
            </div>
        )
    }
}

export { ConfirmSignUp }
